import React from 'react';
import firebase from '../../firebase';
import { Segment, Comment } from 'semantic-ui-react';

import MessagesHeader from './MessagesHeader';
import MessagesInputArea from './MessagesInputArea';
import Message from './Message';

class MessagesArea extends React.Component {

  // Initial State
  state = {
    privateChannel: this.props.isPrivateChannel,
    privateMessagesRef: firebase.database().ref("privateMessages"),
    messagesRef: firebase.database().ref("messages"),
    messages: [],
    messagesLoading: true,
    channel: this.props.currentChannel,
    isChannelFavourited: false,
    user: this.props.currentUser,
    usersRef: firebase.database().ref("users"),
    numUniqueUsers: "",
    searchTerm: "",
    searchLoading: false,
    searchResults: [],
    listeners: [],
  };

  // React Lifecycle Methods
  componentDidMount() {
    const { channel, user, listeners } = this.state;

    if (channel && user) {
      this.removeListeners(listeners);
      if(this.isValidChannel()){
        this.addListeners(channel.id);
        this.addUserStarListeners(channel.id, user.uid);
      }
    }
  }

  componentWillUnmount() {
    this.removeListeners(this.state.listeners);
  }

  removeListeners = (listeners) => {
    listeners.forEach((listener) => {
      listener.ref.child(listener.id).off(listener.event);
    });
  };

  componentDidUpdate() {
    if (this.messagesEnd) {
      this.scrollToBottom();
    }
  }

  // Adds to listeners method
  addToListeners = (id, ref, event) => {
    const index = this.state.listeners.findIndex((listener) => {
      return (
        listener.id === id && listener.ref === ref && listener.event === event
      );
    });

    if (index === -1) {
      const newListener = { id, ref, event };
      this.setState({ listeners: this.state.listeners.concat(newListener) });
    }
  };

  // When app loads messages scroll to bottom
  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  };

  // Maps channelID to the message
  addListeners = (channelId) => {
    this.addMessageListener(channelId);
  };

  // Function that appends channel messages to the Firebase realtime database
  addMessageListener = (channelId) => {
    let loadedMessages = [];
    const ref = this.getMessagesRef();
    ref.child(channelId).on("child_added", (snap) => {
      loadedMessages.push(snap.val());
      this.setState({
        messages: loadedMessages,
        messagesLoading: false,
      });
      this.countUniqueUsers(loadedMessages);
    });
    this.addToListeners(channelId, ref, "child_added");
  };

  // Reads Firebase realtime database and checks if user has starred a specific channel
  addUserStarListeners = (channelId, userId) => {
    this.state.usersRef
      .child(userId)
      .child("favourited")
      .once("value")
      .then((data) => {
        if (data.val() !== null) {
          const channelIds = Object.keys(data.val());
          const prevFavourited = channelIds.includes(channelId);
          this.setState({ isChannelFavourited: prevFavourited });
        }
      });
  };

  // Gets messages reference
  getMessagesRef = () => {
    const { messagesRef, privateMessagesRef, privateChannel } = this.state;
    return privateChannel ? privateMessagesRef : messagesRef;
  };

  // Handles star state if it is favourited or not
  handleStar = () => {
    this.setState(
      (prevState) => ({
        isChannelFavourited: !prevState.isChannelFavourited,
      }),
      () => this.favouriteChannel()
    );
  };

  // Adds favourited channels to the database for user
  favouriteChannel = () => {
    if (this.state.isChannelFavourited) {
      this.state.usersRef.child(`${this.state.user.uid}/favourited`).update({
        [this.state.channel.id]: {
          name: this.state.channel.name,
          details: this.state.channel.details,
          createdBy: {
            name: this.state.channel.createdBy.name,
            avatar: this.state.channel.createdBy.avatar,
            id: this.state.channel.createdBy.id,
          },
        },
      });
    } else {
      this.state.usersRef
        .child(`${this.state.user.uid}/favourited`)
        .child(this.state.channel.id)
        .remove((err) => {
          if (err !== null) {
            console.error(err);
          }
        });
    }
  };

  // Changes and shows messages that are searched
  handleSearchChange = (event) => {
    this.setState(
      {
        searchTerm: event.target.value,
        searchLoading: true,
      },
      () => this.handleSearchMessages()
    );
  };

  // Pushes the messages to the chat area and handles the state of search
  handleSearchMessages = () => {
    const channelMessages = [...this.state.messages];
    const regex = new RegExp(this.state.searchTerm, "gi");
    const searchResults = channelMessages.reduce((acc, message) => {
      if (
        (message.content && message.content.match(regex)) ||
        message.user.name.match(regex)
      ) {
        acc.push(message);
      }
      return acc;
    }, []);
    this.setState({ searchResults });
    setTimeout(() => this.setState({ searchLoading: false }), 1000);
  };

  // Counts unique user for search feature, that user is displayed with their messages
  countUniqueUsers = (messages) => {
    const uniqueUsers = messages.reduce((acc, message) => {
      if (!acc.includes(message.user.name)) {
        acc.push(message.user.name);
      }
      return acc;
    }, []);
    const numUniqueUsers =
      uniqueUsers.length === 1 ? "1 user" : `${uniqueUsers.length} users`;
    this.setState({ numUniqueUsers });
  };

  // Function that displayed messages
  displayMessages = (messages) =>
    messages.length > 0 &&
    messages.map((message) => (
      <Message
        key={message.timestamp}
        message={message}
        user={this.state.user}
      />
    ));

    isValidChannel = () => {
      let channel = this.state.channel;
      let privateChannel = this.state.privateChannel;
      let user = this.state.user;

      console.log('channel',channel);
      console.log('privateChannel',privateChannel);
      console.log('user',user);
      if(privateChannel){
        return true;
      }
      if(channel && (channel.createdBy.id == user.uid || 
        (channel.users && (channel.users.indexOf(user.uid) > -1)))){
        return true;
      }
      return false;
    }

  // Shows channel name in the messages area
  displayChannelName = (channel) => {
    return channel
      ? `${this.state.privateChannel ? "@" : "#"}${channel.name}`
      : "";
  };

  // React Render function that handles the state changes with the above created functions and displayed with Semantic UI's React Components
  render() {
    const {
      messagesRef,
      messages,
      channel,
      user,
      numUniqueUsers,
      searchTerm,
      searchResults,
      searchLoading,
      privateChannel,
      isChannelFavourited,
    } = this.state;

    return (
      <React.Fragment>
        {
          this.isValidChannel() && 
            <MessagesHeader
              channelName={this.displayChannelName(channel)}
              numUniqueUsers={numUniqueUsers}
              handleSearchChange={this.handleSearchChange}
              searchLoading={searchLoading}
              isPrivateChannel={privateChannel}
              handleStar={this.handleStar}
              isChannelFavourited={isChannelFavourited}
            />
        }
         {
          this.isValidChannel() ?
            <Segment style={{ overflow: "auto", maxHeight: 500 }}>
              <Comment.Group className="messages">
                {searchTerm
                  ? this.displayMessages(searchResults)
                  : this.displayMessages(messages)}
                <div ref={(node) => (this.messagesEnd = node)}></div>
              </Comment.Group>
            </Segment> :
            <Segment style={{ overflow: "auto", maxHeight: 500 }}>Welcome to Pulse ChatApp</Segment>
        }
        {
          this.isValidChannel() && 
          <MessagesInputArea
          messagesRef={messagesRef}
          currentChannel={channel}
          currentUser={user}
          isPrivateChannel={privateChannel}
          getMessagesRef={this.getMessagesRef}
        />
        }
      </React.Fragment>
    );
  }
}

export default MessagesArea;
